/**
 * Contact Form API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContactFormResponse { 
    id: number;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    subject: ContactFormResponse.SubjectEnum;
    message: string;
    status: ContactFormResponse.StatusEnum;
    createdAt: string;
}
export namespace ContactFormResponse {
    export const SubjectEnum = {
        Inquiry: 'INQUIRY',
        Consultation: 'CONSULTATION',
        QuotationRequest: 'QUOTATION_REQUEST',
        Feedback: 'FEEDBACK',
        Other: 'OTHER'
    } as const;
    export type SubjectEnum = typeof SubjectEnum[keyof typeof SubjectEnum];
    export const StatusEnum = {
        New: 'NEW',
        Read: 'READ',
        Responded: 'RESPONDED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


